

// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import styles from "./BallroomDetails.module.css";
// import { getVenuePlannerData } from "../venuePlannerApi";

// import PageMeta from "../Breadcrumb/PageMeta";
// import Breadcrumb from "../Breadcrumb/Breadcrumb";
// import TableOfContents from "../TableOfContents/TableOfContents";

// import BallroomHero from "./BallroomHero";

// import BallroomOverview from "./BallroomOverview";
// import CapacityCards from "./CapacityCards";
// import Gallery from "./Gallery";
// import PreFunctionArea from "./PreFunctionArea";
// import ModelViewer from "./ModelViewer";


// export default function BallroomDetails() {
// //   const tableOfContents = [
// //   {
// //     id: "overview",
// //     label: "Overview",
// //   },

// //   {
// //     id: "capacity",
// //     label: "Capacity",
// //   },
 
// //   {
// //     id: "gallery",
// //     label: "Gallery",
// //   },
// //   {
// //     id: "pre-function-area",
// //     label: "Pre-Function Area",
// //   },
// // ];



//   const { hotelSlug, ballroomSlug } = useParams();

//   const [hotel, setHotel] = useState(null);
//   const [ballroom, setBallroom] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     loadBallroom();
//   }, [hotelSlug, ballroomSlug]);

//   const loadBallroom = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const hotels = await getVenuePlannerData();

//       const selectedHotel = hotels.find(
//         (hotel) => hotel.slug === hotelSlug
//       );

//       if (!selectedHotel) {
//         setError("Hotel not found.");
//         return;
//       }

//       const selectedBallroom = selectedHotel.ballrooms?.find(
//         (ballroom) => ballroom.slug === ballroomSlug
//       );

//       if (!selectedBallroom) {
//         setError("Ballroom not found.");
//         return;
//       }

//       setHotel(selectedHotel);
//       setBallroom(selectedBallroom);
//     } catch (err) {
//       console.error(err);
//       setError("Unable to load ballroom details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <main
//         style={{
//           minHeight: "50vh",
//           display: "grid",
//           placeItems: "center",
//         }}
//       >
//         <h2>Loading Ballroom...</h2>
//       </main>
//     );
//   }

//   if (error) {
//     return (
//       <main
//         style={{
//           minHeight: "50vh",
//           display: "grid",
//           placeItems: "center",
//         }}
//       >
//         <h2>{error}</h2>
//       </main>
//     );
//   }

//   const pageTitle = `${ballroom.name} | ${hotel.name} | Ballroom Capacity, Dimensions & Venue Details | Atlas Travel House`;

//   const pageDescription =
//     ballroom.description ||
//     `${ballroom.name} at ${hotel.name}, ${hotel.city}. Explore seating capacity, dimensions, specifications, gallery, pre-function area and 3D walkthrough for weddings, conferences and corporate events.`;





//     const tableOfContents = [
//   {
//     id: "overview",
//     label: "Overview",
//   },

//   ballroom?.capacities?.length > 0 && {
//     id: "capacity",
//     label: "Capacity",
//   },

//   ballroom?.images?.length > 0 && {
//     id: "gallery",
//     label: "Gallery",
//   },

//   ballroom?.pre_function_area && {
//     id: "pre-function-area",
//     label: "Pre-Function Area",
//   },
// ].filter(Boolean);
// return (
//   <>
//     <PageMeta
//       title={pageTitle}
//       description={pageDescription}
//     />

//     <Breadcrumb
//       items={[
//         {
//           label: "Venue Planner",
//           path: "/venue-planner",
//         },
//         {
//           label: hotel.state,
//           path: `/venue-planner?state=${encodeURIComponent(
//             hotel.state
//           )}`,
//         },
//         {
//           label: hotel.city,
//           path: `/venue-planner?state=${encodeURIComponent(
//             hotel.state
//           )}&city=${encodeURIComponent(hotel.city)}`,
//         },
//         {
//           label: hotel.name,
//           path: `/venue-planner/hotel/${hotel.slug}`,
//         },
//         {
//           label: ballroom.name,
//         },
//       ]}
//     />

//     <main>
   
//       <BallroomHero
//         hotel={hotel}
//         ballroom={ballroom}
//       />
//    <TableOfContents
//     items={tableOfContents}
//   />
//       {/* <section
//         id="overview"
//         aria-labelledby="ballroom-overview"
//       >
//         <BallroomOverview
//           hotel={hotel}
//           ballroom={ballroom}
//         />
//       </section>

    
//       <section
//         id="capacity"
//         aria-labelledby="ballroom-capacity"
//       >
//         <CapacityCards ballroom={ballroom} />
//       </section>

   
//       <section
//         id="gallery"
//         aria-labelledby="ballroom-gallery"
//       >
//         <Gallery ballroom={ballroom} />
//       </section>

//       <section
//         id="pre-function-area"
//         aria-labelledby="pre-function-area"
//       >
//         <PreFunctionArea ballroom={ballroom} />
//       </section> */}

//       <section id="overview">
//   <BallroomOverview
//     hotel={hotel}
//     ballroom={ballroom}
//   />
// </section>

// {ballroom?.capacities?.length > 0 && (
//   <section id="capacity">
//     <CapacityCards ballroom={ballroom} />
//   </section>
// )}

// {ballroom?.images?.length > 0 && (
//   <section id="gallery">
//     <Gallery ballroom={ballroom} />
//   </section>
// )}

// {ballroom?.pre_function_area && (
//   <section id="pre-function-area">
//     <PreFunctionArea ballroom={ballroom} />
//   </section>
// )}



//     </main>
//   </>
// );
// }




import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./BallroomDetails.module.css";
import { getVenuePlannerData } from "../venuePlannerApi";

import PageMeta from "../Breadcrumb/PageMeta";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import TableOfContents from "../TableOfContents/TableOfContents";

import BallroomHero from "./BallroomHero";

import BallroomOverview from "./BallroomOverview";
import CapacityCards from "./CapacityCards";
import Gallery from "./Gallery";
import PreFunctionArea from "./PreFunctionArea";
import ModelViewer from "./ModelViewer";
import BallroomGrid from "./BallroomGrid";

export default function BallroomDetails() {
  const { hotelSlug, ballroomSlug } = useParams();

  const [hotel, setHotel] = useState(null);
  const [ballroom, setBallroom] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    loadBallroom();
  }, [hotelSlug, ballroomSlug]);

  const loadBallroom = async () => {
    try {
      setLoading(true);
      setError("");

      const hotels = await getVenuePlannerData();

      const selectedHotel = hotels.find(
        (hotel) => hotel.slug === hotelSlug
      );

      if (!selectedHotel) {
        setError("Hotel not found.");
        return;
      }

      const selectedBallroom = selectedHotel.ballrooms?.find(
        (ballroom) => ballroom.slug === ballroomSlug
      );

      if (!selectedBallroom) {
        setError("Ballroom not found.");
        return;
      }

      setHotel(selectedHotel);
      setBallroom(selectedBallroom);
    } catch (err) {
      console.error(err);
      setError("Unable to load ballroom details.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <main
        style={{
          minHeight: "50vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <h2>Loading Ballroom...</h2>
      </main>
    );
  }

  if (error) {
    return (
      <main
        style={{
          minHeight: "50vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <h2>{error}</h2>
      </main>
    );
  }

  const pageTitle = `${ballroom.name} | ${hotel.name} | Ballroom Capacity, Dimensions & Venue Details | Atlas Travel House`;

  const pageDescription =
    ballroom.description ||
    `${ballroom.name} at ${hotel.name}, ${hotel.city}. Explore seating capacity, dimensions, specifications, gallery, pre-function area and 3D walkthrough for weddings, conferences and corporate events.`;





    const tableOfContents = [
  {
    id: "overview",
    label: "Overview",
  },

  ballroom?.capacities?.length > 0 && {
    id: "capacity",
    label: "Capacity",
  },

  ballroom?.images?.length > 0 && {
    id: "gallery",
    label: "Gallery",
  },

  ballroom?.pre_function_area && {
    id: "pre-function-area",
    label: "Pre-Function Area",
  },
  hotel?.ballrooms?.length > 1 &&{
    id:"other-ballrooms",
    label :"Other-Ballrooms",
  },

].filter(Boolean);
return (
  <>
    <PageMeta
      title={pageTitle}
      description={pageDescription}
    />

    <Breadcrumb
      items={[
        {
          label: "Venue Planner",
          path: "/venue-planner",
        },
        {
          label: hotel.state,
          path: `/venue-planner?state=${encodeURIComponent(
            hotel.state
          )}`,
        },
        {
          label: hotel.city,
          path: `/venue-planner?state=${encodeURIComponent(
            hotel.state
          )}&city=${encodeURIComponent(hotel.city)}`,
        },
        {
          label: hotel.name,
          path: `/venue-planner/hotel/${hotel.slug}`,
        },
        {
          label: ballroom.name,
        },
      ]}
    />

    <main>
   
      <BallroomHero
        hotel={hotel}
        ballroom={ballroom}
      />
   <TableOfContents
    items={tableOfContents}
  />

      <section id="overview">
  <BallroomOverview
    hotel={hotel}
    ballroom={ballroom}
  />
</section>

{ballroom?.capacities?.length > 0 && (
  <section id="capacity">
    <CapacityCards ballroom={ballroom} />
  </section>
)}

{ballroom?.images?.length > 0 && (
  <section id="gallery">
    <Gallery ballroom={ballroom} />
  </section>
)}

{ballroom?.pre_function_area && (
  <section id="pre-function-area">
    <PreFunctionArea ballroom={ballroom} />
  </section>
)}

{hotel?.ballrooms?.length > 1 && (
  <section id="other-ballrooms">
    <BallroomGrid
      hotel={hotel}
      ballrooms={hotel.ballrooms}
      currentBallroom={ballroom}
      variant="other"
    />
  </section>
)}


    </main>
  </>
);
}